import { Box, useMediaQuery } from "@mui/material";

export const PhoneSimulator = ({ children }) => {
  const isScreenLarge = useMediaQuery("(min-width:500px)");

  if (!isScreenLarge) {
    return <>{children}</>;
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
      }}
    >
      <Box
        sx={{
          width: "50%",
          minWidth: "320px",
          maxWidth: "420px",
          height: "100vh",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
